import PropTypes from 'prop-types';

import answerModes from '../constants/answer_modes';

const modes = Object.keys(answerModes).map(key => answerModes[key].id);
export default PropTypes.oneOf(modes);
